<template>
  <v-layout>
    <MainMenu />
    <v-layout column>
      <v-layout>
        <v-flex>
          <listPagesHeader
            :page-title="''"
            :show-btn="false"
          />
          <div class="page-content-paddings">
            <v-layout>
              <v-flex xs12>
                <h1 class="mb-4">
                  {{ $t('dashboard.title') }}
                </h1>
                <p class="f-2">
                  {{ $t('dashboard.message') }}
                  <a :href="'mailto:' + mail">{{ $t('dashboard.mail_web') }}.</a>
                  {{ $t('dashboard.message_2') }}
                  <a :href="'mailto:' + mailVolunteer">{{ $t('dashboard.mail_volunteer') }}.</a>
                </p>
                <p class="f-2">
                  {{ $t('dashboard.message_3') }}
                </p>
              </v-flex>
            </v-layout>
            <v-layout
              v-if="errorsMessages"
              wrap
            >
              <v-flex
                v-for="(error, index) in errorsMessages"
                :key="index"
                xs12
                class="mb-3"
              >
                <v-alert value="true">
                  <v-layout justify-between>
                    <v-flex>
                      <h3 class="display-2">
                        {{ error.header }}
                      </h3>
                    </v-flex>
                    <v-flex class="none-growth">
                      {{ error.date }}
                    </v-flex>
                  </v-layout>
                  <p
                    class="mb-0"
                    v-html="sanitizeHtml(error.content)"
                  />
                </v-alert>
              </v-flex>
            </v-layout>
            <v-layout
              v-if="notifications"
              wrap
            >
              <v-flex
                v-for="(notification, index) in notifications"
                :key="index"
                xs12
                class="mb-3"
              >
                <v-alert
                  value="true"
                  type="info"
                  :icon="' '"
                >
                  <v-layout>
                    <v-flex>
                      <h3 class="display-2">
                        {{ notification.header }}
                      </h3>
                    </v-flex>
                    <v-flex class="none-growth">
                      {{ notification.date }}
                    </v-flex>
                  </v-layout>
                  <p
                    class="mb-0"
                    v-html="sanitizeHtml(notification.content)"
                  />
                </v-alert>
              </v-flex>
            </v-layout>
            <BNPHomeSponsorBox />
          </div>
        </v-flex>
      </v-layout>
      <v-layout
        fill-height
        align-end
      >
        <v-flex class="footer-wrap">
          <div class="page-content-paddings">
            <AppFooter class="mb-3" />
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>
<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import AppFooter from '@/components/widgets/AppFooter';
import listPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import sanitize from 'sanitize-html';
import BNPHomeSponsorBox from '@/components/widgets/BNPHomeSponsorBox';

export default {
    name: 'HomePage',
    components: {
        BNPHomeSponsorBox,
        AppFooter,
        MainMenu,
        listPagesHeader
    },
    beforeRouteEnter (from, to, next) {
        next((vm) => {
            vm.$store.dispatch('customContent/getCustomContent');
        });
    },
    computed: {
        mail () {
            return this.$t('dashboard.mail_web');
        },
        mailVolunteer () {
            return this.$t('dashboard.mail_volunteer');
        },
        messages () {
            return this.$store.getters['customContent/getCustomContent'];
        },
        errorsMessages () {
            if (this.messages) {
                return Object.prototype.hasOwnProperty.call(this.messages, 'errors')
                    ? this.messages.errors
                    : false;
            }
            return false;
        },
        notifications () {
            if (this.messages) {
                return Object.prototype.hasOwnProperty.call(this.messages, 'notifications')
                    ? this.messages.notifications
                    : false;
            }
            return false;
        }
    },
    updated () {
        this.$nextTick(function () {
            const dataLayerVariables = {
                event: 'show_hotjar_survey_w_lr_szp'
            };

            const roles = this.$store.getters['auth/getRoles'];
            for (const i in roles) {
                dataLayerVariables['role_' + roles[i]] = 'role_active';
            }

            this.$gtm.trackEvent(dataLayerVariables);
        });
    },
    methods: {
        sanitizeHtml (html) {
            return sanitize(html, {
                allowedTags: ['a', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'br', 'ul', 'li'],
                allowedAttributes: {
                    a: ['href', 'class', 'target'],
                    p: ['class'],
                    h1: ['class'],
                    h2: ['class'],
                    h3: ['class'],
                    h4: ['class'],
                    h5: ['class'],
                    h6: ['class'],
                    ul: ['class'],
                    li: ['class']
                }
            });
        }
    }
};
</script>
<style lang="scss"></style>
